import { ExpectedError } from "../../expectedError";

export type WinrmDefaults = { port: string };

const WINRM_PASSWORD_PLACEHOLDER = "__3B_WINRM_PASSWORD_PLACEHOLDER__";

function hostComponent(host: string | undefined) {
  const value = (host ?? "").trim();
  if (/^\[[0-9a-fA-F:.]+\]$/.test(value)) return value;
  if (!/^[A-Za-z0-9.-]+$/.test(value)) {
    throw new ExpectedError("Invalid WinRM host");
  }
  return value;
}

function portComponent(port: string | undefined, defaultPort: string) {
  const value = (port || defaultPort).trim();
  if (!/^\d+$/.test(value)) throw new ExpectedError("Invalid WinRM port");
  const portNumber = Number(value);
  if (portNumber < 1 || portNumber > 65535) {
    throw new ExpectedError("Invalid WinRM port");
  }
  return value;
}

export function endpoint(
  host: string | undefined,
  port: string | undefined,
  defaults: WinrmDefaults
) {
  return `https://${hostComponent(host)}:${portComponent(port, defaults.port)}/wsman`;
}

export function publicEnvVars(
  { host, port, username }: Record<string, string>,
  defaults: WinrmDefaults
) {
  return {
    WINRM_HOST: hostComponent(host),
    WINRM_PORT: portComponent(port, defaults.port),
    WINRM_ENDPOINT: endpoint(host, port, defaults),
    WINRM_USERNAME: username ?? "",
    WINRM_PASSWORD: WINRM_PASSWORD_PLACEHOLDER,
  };
}
